import { PLANT_API_BASE_URL } from 'shared/constants/constants';

export const PlantItemRenewalConstants = {
  licenceType: 'PIRR',
  licenceDuration: '1',
  applicantType: 'individual',
  transactionType: 'Renewal',
  licenceTypeDescription: 'Plant Item Registration - Renew/Restore',
  snswLandingPageUrl: 'https://www.service.nsw.gov.au/transaction/apply-to-renew-the-registration-of-an-item-of-plant',
  renewalSearchInputType: {
    renewalNumber: 1,
    itemRegistrationNumber: 2,
  },
  peopleRecordType: {
    individual: 'Individual',
    organisation: 'Organization',
  },
};

export const PLANT_ITEM_RENEWAL_API_BASE_URL = `${PLANT_API_BASE_URL}/item/renewal`;
